import { create } from 'zustand'
import {
  ResolvedTheme,
  ThemePreference,
  applyTheme,
  readStoredPreference,
  readSystemScheme,
  resolveTheme,
  writeStoredPreference,
} from '@/lib/theme'

interface ThemeState {
  /** Что выбрал пользователь. */
  preference: ThemePreference
  /** Что просит платформа (Telegram / ОС) — имеет смысл только при `system`. */
  systemScheme: ResolvedTheme
  /** Что фактически нарисовано. */
  resolved: ResolvedTheme
  setPreference: (preference: ThemePreference) => void
  /** Зовётся слушателями платформы, выбор пользователя не трогает. */
  setSystemScheme: (scheme: ResolvedTheme) => void
}

/**
 * ⚠️ Персист сделан вручную плоским ключом, а НЕ через `zustand/persist`:
 * тот же ключ читает инлайн-скрипт анти-вспышки в `index.html`, который не
 * может разбирать формат сериализации middleware. См. `THEME_STORAGE_KEY`.
 */
export const useThemeStore = create<ThemeState>()((set, get) => {
  const preference = readStoredPreference()
  const systemScheme = readSystemScheme()
  const resolved = resolveTheme(preference, systemScheme)

  // Инлайн-скрипт уже поставил атрибут; повтор безвреден и страхует SSR/тесты.
  applyTheme(resolved)

  return {
    preference,
    systemScheme,
    resolved,
    setPreference: (next) => {
      writeStoredPreference(next)
      const nextResolved = resolveTheme(next, get().systemScheme)
      applyTheme(nextResolved)
      set({ preference: next, resolved: nextResolved })
    },
    setSystemScheme: (scheme) => {
      const state = get()
      if (state.systemScheme === scheme) return
      const nextResolved = resolveTheme(state.preference, scheme)
      applyTheme(nextResolved)
      set({ systemScheme: scheme, resolved: nextResolved })
    },
  }
})
